export default __webpack_public_path__ + "static/media/Mystic's Coverings of Shimmering Light.acbcb3a0.jpg";